const name = "g-file-upload";
export default {
  name,

  components: {},

  props: {
    uploadedFiles: {
      type: Object,
      default: [],
    },
    imagem: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: Boolean,
      default: false,
    },
    documento: {
      type: Boolean,
      default: false,
    },
    pdf: {
      type: Boolean,
      default: false,
    },
    imagemPdf: {
      type: Boolean,
      default: false
    },
    arquivoMultiplo: {
      type: Boolean,
      default: false,
    },
    customUpload: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    this.aceitos = this.imagem && this.aceitos === '*' ? 'image/*' : this.aceitos;
    this.aceitos = this.audio && this.aceitos === '*' ? 'audio/*' : this.aceitos;
    this.aceitos = this.documento && this.aceitos === '*' ? '.doc,.docx,.txt' : this.aceitos;
    this.aceitos = this.pdf && this.aceitos === '*' ? 'application/pdf' : this.aceitos;
    this.aceitos = this.imagemPdf && this.aceitos === '*' ? '.jpeg, .png, .jpg, .pdf' : this.aceitos;
  },

  updated() {},

  data() {
    return {
      aceitos: '*',
    };
  },

  methods: {
    upload(e){
      this.$emit('upload', e)
    },
    edit() {
      this.$emit('edit');
    }
  },
  watch: {
 
  },
  computed: {},
};
